import React from "react";

import {
    FiFilter,
    FiSearch,
    FiX,
} from "react-icons/fi";

import {
    LEDGER_TABS,
} from "./LedgerTabs";

/*
|--------------------------------------------------------------------------
| COMPONENT
|--------------------------------------------------------------------------
*/

const LedgerToolbar = ({
    activeTab,

    search = "",

    entryType = "",

    onSearchChange,

    onEntryTypeChange,

    onClearSearch,
}) => {
    const isCustomerTab =
        activeTab ===
        LEDGER_TABS.CUSTOMERS;

    return (
        <section className="customer-ledger-toolbar">
            <div className="customer-ledger-toolbar-search">
                <FiSearch />

                <input
                    type="text"
                    value={
                        search
                    }
                    placeholder={
                        isCustomerTab
                            ? "Search customer name, mobile or email..."
                            : "Search customer, mobile, invoice, payment or reference..."
                    }
                    onChange={(
                        event
                    ) =>
                        onSearchChange?.(
                            event.target.value
                        )
                    }
                />

                {search && (
                    <button
                        type="button"
                        className="customer-ledger-search-clear"
                        title="Clear search"
                        onClick={
                            onClearSearch
                        }
                    >
                        <FiX />
                    </button>
                )}
            </div>

            {!isCustomerTab && (
                <div className="customer-ledger-toolbar-filter">
                    <FiFilter />

                    <select
                        value={
                            entryType
                        }
                        onChange={(
                            event
                        ) =>
                            onEntryTypeChange?.(
                                event
                                    .target
                                    .value
                            )
                        }
                    >
                        <option value="">
                            All Transactions
                        </option>

                        <option value="SALE_INVOICE">
                            Sale Invoice
                        </option>

                        <option value="INVOICE">
                            Invoice
                        </option>

                        <option value="PAYMENT">
                            Payment
                        </option>

                        <option value="CREDIT_NOTE">
                            Credit Note
                        </option>

                        <option value="ADJUSTMENT">
                            Adjustment
                        </option>

                        <option value="REVERSAL">
                            Reversal
                        </option>

                        <option value="PAYMENT_REVERSAL">
                            Payment Reversal
                        </option>
                    </select>
                </div>
            )}
        </section>
    );
};

export default LedgerToolbar;